import React, { useState } from 'react';
import { Reveal } from '../ui/Reveal';

export const Team = () => {
  // Update 1: Track the specific member's name instead of true/false
  const [activeMember, setActiveMember] = useState(null);

  // Update 2: Pass the member's name into the toggle function
  const toggleMobileTeam = (memberName) => {
    if (window.matchMedia("(pointer:coarse)").matches) {
      // If clicking the currently open card, close it. Otherwise, open the new one.
      setActiveMember(activeMember === memberName ? null : memberName);
    }
  };

  return (
    <section className="sec" id="team">
      <Reveal><div className="slabel">The Core</div></Reveal>
      <Reveal delay="1"><h2 className="stitle">Our <em>Team</em></h2></Reveal>
      <div className="team-grid">
        
        {/* Existing Member: Mayur */}
        <Reveal delay="1.5">
          <div
            // Update 3: Check if THIS member is the active one
            className={`team-card ${activeMember === 'mayur' ? 'mobile-active' : ''}`}
            onClick={() => toggleMobileTeam('mayur')}
          >
            <div className="team-img-container">
              <img src="/assets/mayur.jpg" alt="Mayur" className="team-img" />
              <div className="team-overlay">
                <div className="team-name">Mayur</div>
                <div className="team-role">Founder</div>
                <div className="team-hidden-content">
                  <p className="team-bio">
                    "Founder, full-stack developer 👨‍💻, and full-time believer that every bug is just a feature that hasn't been explained properly yet 🐛✨. Has a complicated relationship with Git 🌀 — mostly one-sided, mostly his fault. Runs on 90% caffeine ☕, 10% Stack Overflow 📚, and 100% conviction that the bug is somewhere else 🤷‍♂️. Firmly believes every problem can be solved with more logging 📊 or more chai ☕ — and if it works on his machine but not on yours, well, that's just a feature too. 🚀"
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        {/* New Member: Dr. M N Faruk */}
        {/* <Reveal delay="1.7">
          <div
            // Update 4: Check if THIS member is the active one
            className={`team-card ${activeMember === 'faruk' ? 'mobile-active' : ''}`}
            onClick={() => toggleMobileTeam('faruk')}
          >
            <div className="team-img-container">
              <img src="/assets/M.N.Faruk.jpeg" alt="Dr. M.N.Faruk" className="team-img" />
              <div className="team-overlay">
                <div className="team-name">Dr. M N Faruk</div>
                <div className="team-role">Consultant</div>
                <div className="team-hidden-content">
                  <p className="team-bio">
                    "Dr. M. N. Faruk holds a Ph.D. in Computer Science and Engineering, specializing in Cloud Computing Resource Management, from BIHER, Chennai (2016), and completed a Postdoctoral Fellowship at the Singapore Institute of Technology, Singapore (2025–2026). With over 16 years of academic and professional experience, Dr. Faruk has contributed significantly to teaching, research, technology, and academic administration. Currently, he serves as the Head of IT, East Point Group of Institutions, and as a Professor in the Department of Computer Science and Engineering, East Point College of Engineering and Technology. His expertise encompasses IT leadership, digital transformation, cloud computing, research, and technology-driven institutional development."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Reveal> */}

      </div>
      <Reveal delay="2">
        <p className="team-note">
          Yet some more need to be joined — the guys who did join aren't ready to share their profile yet, or our developer is just too lazy to update this section. 😅
        </p>
      </Reveal>
    </section>
  );
};